export const mediaItems = [
  {
    id: 'media-1',
    title: '《星际穿越》经典重温',
    tag: '科幻巨制',
    duration: '2:49:03',
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20astronaut%20floating%20near%20a%20massive%20black%20hole%2C%20warm%20golden%20accretion%20disk%20glow%2C%20deep%20space%20background%20with%20stars%2C%20dramatic%20film%20lighting%2C%20movie%20poster%20quality%2C%20emotional%20and%20grand%20scale%2C%20soft%20lens%20flare%2C%20cinematic%20composition&width=800&height=450&seq=media-1-x9&orientation=landscape',
    desc: '诺兰经典科幻巨作，IMAX 画质震撼呈现',
  },
  {
    id: 'media-2',
    title: '《繁花》沪上风云',
    tag: '年代大剧',
    duration: '30 集全',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20bund%20at%20night%20with%20vintage%201990s%20nostalgic%20atmosphere%2C%20neon%20lights%20reflecting%20on%20Huangpu%20River%2C%20elegant%20period%20drama%20visual%2C%20warm%20amber%20and%20gold%20tones%2C%20cinematic%20cityscape%2C%20soft%20film%20grain%2C%20romantic%20urban%20night%20scene&width=800&height=450&seq=media-2-x9&orientation=landscape',
    desc: '王家卫首部剧集，九十年代上海商战与情感交织',
  },
  {
    id: 'media-3',
    title: '《歌手2025》巅峰对决',
    tag: '音乐综艺',
    duration: '第 8 期',
    image: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20spotlight%20and%20atmospheric%20fog%2C%20warm%20golden%20stage%20lighting%2C%20music%20performance%20venue%2C%20elegant%20theater%20setting%2C%20professional%20production%20quality%2C%20warm%20red%20and%20amber%20tones%2C%20cinematic%20live%20show%20visual&width=800&height=450&seq=media-3-x9&orientation=landscape',
    desc: '华语乐坛顶级歌手同台，每一场都是视听盛宴',
  },
  {
    id: 'media-4',
    title: '《周处除三害》全网首播',
    tag: '犯罪动作',
    duration: '2:14:20',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20film%20scene%20with%20silhouetted%20figure%20in%20dark%20urban%20alley%2C%20dramatic%20shadows%20and%20warm%20street%20light%2C%20cinematic%20noir%20atmosphere%2C%20film%20grain%20texture%2C%20suspenseful%20mood%2C%20warm%20red%20and%20deep%20shadow%20tones%2C%20movie%20poster%20aesthetic&width=800&height=450&seq=media-4-x9&orientation=landscape',
    desc: '阮经天转型力作，台湾黑帮题材犯罪片口碑炸裂',
  },
];

export const appEntry = {
  title: '牛牛影视 APP',
  subtitle: '随时随地，高清追剧',
  desc: '支持 iOS / Android 双平台，离线缓存、投屏播放、弹幕互动，移动观影体验全面升级。海量影视资源随身携带，通勤路上也能畅享大片。',
  features: ['离线缓存', '高清投屏', '弹幕互动', '智能推荐'],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%2C%20clean%20UI%20design%2C%20warm%20dark%20theme%2C%20elegant%20mobile%20app%20screen%2C%20cinematic%20red%20and%20gold%20accent%20colors%2C%20minimalist%20product%20photography%2C%20soft%20studio%20lighting&width=600&height=900&seq=app-entry-x9&orientation=portrait',
};

export const carouselItems = [
  {
    id: 'carousel-1',
    title: '暑期档必看片单',
    subtitle: '2025 年暑假最值得期待的 20 部电影',
    tag: '专题策划',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20themed%20collage%20with%20golden%20sunset%20beach%20and%20film%20reel%20elements%2C%20warm%20vibrant%20summer%20colors%2C%20movie%20marquee%20lights%2C%20festive%20entertainment%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20hour%20lighting%2C%20film%20poster%20collection%20vibe&width=1000&height=560&seq=carousel-1-x9&orientation=landscape',
  },
  {
    id: 'carousel-2',
    title: '国产悬疑剧崛起',
    subtitle: '从《漫长的季节》到《隐秘的角落》',
    tag: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20misty%20forest%20scene%20with%20soft%20fog%20and%20dappled%20sunlight%2C%20atmospheric%20suspense%20mood%2C%20warm%20earthy%20tones%2C%20cinematic%20thriller%20aesthetic%2C%20film%20noir%20inspired%20lighting%2C%20mysterious%20and%20contemplative%20visual%20storytelling&width=1000&height=560&seq=carousel-2-x9&orientation=landscape',
  },
  {
    id: 'carousel-3',
    title: '韩剧年度盘点',
    subtitle: '2024-2025 年度口碑韩剧 TOP 15',
    tag: '年度榜单',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20cherry%20blossoms%20and%20warm%20spring%20lighting%2C%20soft%20pastel%20and%20golden%20tones%2C%20cinematic%20romance%20visual%2C%20elegant%20couple%20silhouette%20under%20blooming%20trees%2C%20dreamy%20atmosphere%2C%20film%20poster%20style%20composition&width=1000&height=560&seq=carousel-3-x9&orientation=landscape',
  },
  {
    id: 'carousel-4',
    title: '纪录片推荐专场',
    subtitle: 'BBC、Netflix 高分纪录片精选合集',
    tag: '精选合集',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20vast%20savanna%20landscape%20at%20golden%20hour%2C%20wildlife%20silhouettes%2C%20warm%20earth%20tones%2C%20cinematic%20wide%20angle%2C%20natural%20world%20beauty%2C%20professional%20documentary%20photography%20quality%2C%20breathtaking%20vista&width=1000&height=560&seq=carousel-4-x9&orientation=landscape',
  },
];

export const cardItems = [
  {
    id: 'card-1', title: '庆余年 第二季', tag: '古装权谋', rating: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20warm%20lantern%20light%2C%20traditional%20architecture%2C%20elegant%20period%20drama%20atmosphere%2C%20golden%20and%20red%20tones%2C%20cinematic%20costume%20drama%20visual%2C%20soft%20evening%20light%2C%20historical%20Chinese%20aesthetic&width=600&height=400&seq=card-1-x9&orientation=landscape',
    desc: '范闲归来，庙堂江湖风云再起',
  },
  {
    id: 'card-2', title: '阿凡达 3：火与烬', tag: '科幻冒险', rating: '8.9',
    image: 'https://readdy.ai/api/search-image?query=Alien%20jungle%20planet%20with%20bioluminescent%20plants%20and%20warm%20orange%20sky%2C%20fantasy%20landscape%2C%20cinematic%20wide%20shot%2C%20epic%20scale%2C%20warm%20magical%20atmosphere%2C%20James%20Cameron%20style%20visual%2C%20otherworldly%20beauty&width=600&height=400&seq=card-2-x9&orientation=landscape',
    desc: '卡梅隆倾力打造，潘多拉星球全新篇章',
  },
  {
    id: 'card-3', title: '与凤行', tag: '仙侠言情', rating: '8.7',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%20and%20misty%20waterfalls%2C%20warm%20sunrise%20light%2C%20celestial%20atmosphere%2C%20xianxia%20drama%20aesthetic%2C%20golden%20and%20coral%20tones%2C%20dreamy%20visual%20style&width=600&height=400&seq=card-3-x9&orientation=landscape',
    desc: '赵丽颖林更新再度携手，仙魔虐恋',
  },
  {
    id: 'card-4', title: '鱿鱼游戏 第二季', tag: '悬疑惊悚', rating: '9.1',
    image: 'https://readdy.ai/api/search-image?query=Surreal%20colorful%20staircase%20in%20minimalist%20space%2C%20warm%20pink%20and%20mint%20pastel%20tones%2C%20mysterious%20atmosphere%2C%20Korean%20drama%20aesthetic%2C%20geometric%20architecture%2C%20suspenseful%20visual%2C%20clean%20modern%20composition&width=600&height=400&seq=card-4-x9&orientation=landscape',
    desc: '456 号玩家回归，游戏再度开启',
  },
  {
    id: 'card-5', title: '热辣滚烫', tag: '喜剧励志', rating: '8.5',
    image: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20boxing%20gym%20interior%20with%20golden%20light%20streaming%20through%20windows%2C%20inspirational%20atmosphere%2C%20warm%20amber%20tones%2C%20sports%20drama%20visual%2C%20dust%20particles%20in%20light%2C%20cinematic%20composition&width=600&height=400&seq=card-5-x9&orientation=landscape',
    desc: '贾玲自导自演，一场关于自我的蜕变之旅',
  },
  {
    id: 'card-6', title: '唐朝诡事录之西行', tag: '古装探案', rating: '8.8',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20street%20at%20dusk%20with%20red%20lanterns%2C%20mysterious%20atmosphere%2C%20traditional%20architecture%2C%20warm%20glowing%20lights%2C%20period%20mystery%20drama%20visual%2C%20cinematic%20noir%20lighting%2C%20historical%20Chinese%20aesthetic&width=600&height=400&seq=card-6-x9&orientation=landscape',
    desc: '卢凌风苏无名再探奇案，西域迷踪扣人心弦',
  },
  {
    id: 'card-7', title: '封神 第二部', tag: '神话史诗', rating: '9.0',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battlefield%20with%20golden%20divine%20light%20breaking%20through%20storm%20clouds%2C%20ancient%20warriors%20silhouettes%2C%20grand%20scale%20fantasy%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20epic%20composition&width=600&height=400&seq=card-7-x9&orientation=landscape',
    desc: '乌尔善神话宇宙，太师闻仲率大军压境',
  },
];

export const updateItems = [
  { id: 'u1', date: '07-31', tag: '上新', title: '《长安的荔枝》雷佳音主演古装大剧今日上线' },
  { id: 'u2', date: '07-30', tag: '更新', title: '《奔跑吧》第 12 季第 9 期已更新，笑点密集' },
  { id: 'u3', date: '07-30', tag: '热播', title: '《墨雨云间》全网播放量突破 50 亿' },
  { id: 'u4', date: '07-29', tag: '上新', title: '《死侍与金刚狼》高清中字版已上线牛牛影视' },
  { id: 'u5', date: '07-29', tag: '预告', title: '《异形：夺命舰》中文预告首发，8 月 16 日北美上映' },
  { id: 'u6', date: '07-28', tag: '更新', title: '《密室大逃脱》第六季第 6 期密室惊险升级' },
  { id: 'u7', date: '07-28', tag: '热播', title: '《你比星光美丽》谭松韵许凯 CP 感爆棚登顶热搜' },
  { id: 'u8', date: '07-27', tag: '上新', title: '《玫瑰的故事》刘亦菲主演都市情感剧全 38 集上线' },
  { id: 'u9', date: '07-27', tag: '预告', title: '《流浪地球 3》发布首支概念预告，2027 春节档见' },
];

export const featureItems = [
  { id: 'f1', icon: 'ri-4k-line', title: '高清画质', desc: '支持 4K 超清与 HDR 画质，还原影院级观影体验，低带宽也能流畅播放' },
  { id: 'f2', icon: 'ri-flashlight-line', title: '极速加载', desc: '全球 CDN 加速节点覆盖，即点即播不缓冲，追剧零等待' },
  { id: 'f3', icon: 'ri-smartphone-line', title: '多端同步', desc: '手机、平板、电脑无缝切换，播放记录云端同步，随时随地接着看' },
  { id: 'f4', icon: 'ri-tv-2-line', title: '海量片库', desc: '覆盖电影、电视剧、综艺、动漫、纪录片，每日更新最新影视资源' },
  { id: 'f5', icon: 'ri-shield-check-line', title: '绿色安全', desc: '无弹窗广告、无恶意跳转，纯净观影环境，守护你的每一次观看' },
];

export const aboutData = {
  title: '关于牛牛影视',
  content: '牛牛影视是一个专注于高清影视内容聚合的在线平台，致力于为影迷和剧迷打造一站式的追剧观影体验。平台覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日 24 小时不间断更新最新影视资源，让你足不出户即可畅享全球精彩影视。我们采用先进的视频编码技术与全球 CDN 加速网络，确保每一帧画面都清晰流畅。牛牛影视始终坚持用户至上的理念，以纯净无广告的观影环境、智能化的个性推荐和便捷的多端同步功能，成为数千万用户信赖的在线观影首选。',
  stats: [
    { value: '10 万+', label: '影视资源' },
    { value: '5000 万+', label: '月活用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '24 小时', label: '内容更新' },
  ],
};

export const topicItems = [
  { id: 't1', name: '暑期档', heat: '98.6 万讨论', color: 'bg-primary-100 text-primary-700' },
  { id: 't2', name: '古装剧', heat: '87.3 万讨论', color: 'bg-accent-100 text-accent-700' },
  { id: 't3', name: '悬疑推理', heat: '76.8 万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { id: 't4', name: '韩剧', heat: '72.1 万讨论', color: 'bg-primary-100 text-primary-700' },
  { id: 't5', name: '国产动画', heat: '65.4 万讨论', color: 'bg-accent-100 text-accent-700' },
  { id: 't6', name: '综艺', heat: '58.9 万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { id: 't7', name: '科幻大片', heat: '52.3 万讨论', color: 'bg-primary-100 text-primary-700' },
  { id: 't8', name: '纪录片', heat: '41.7 万讨论', color: 'bg-accent-100 text-accent-700' },
  { id: 't9', name: '仙侠剧', heat: '38.5 万讨论', color: 'bg-secondary-100 text-secondary-700' },
];

export const faqItems = [
  {
    q: '牛牛影视需要注册才能观看吗？',
    a: '无需注册即可观看大部分影视内容。我们坚持开放共享的理念，所有公开资源均可直接在线播放。注册账号后可享受收藏、历史记录同步、个性化推荐等增值功能。',
  },
  {
    q: '为什么有些视频加载比较慢？',
    a: '视频加载速度受网络环境和带宽影响。建议检查当前网络连接，或尝试切换清晰度（标清 / 高清 / 超清）。牛牛影视已在全球部署 CDN 加速节点，通常可实现秒级缓冲加载。',
  },
  {
    q: '支持哪些设备观看？',
    a: '牛牛影视全面支持 PC 网页端、手机浏览器、平板设备以及 iOS/Android 客户端 APP。同一账号可在多设备间无缝切换，播放进度云端自动同步。',
  },
  {
    q: '如何反馈影片问题或建议？',
    a: '您可以通过页面底部的联系方式提交反馈，或发送邮件至官方客服邮箱。我们的内容团队每天审核反馈并在 24 小时内处理影片链接异常、画质问题和内容建议。',
  },
];

export const commentItems = [
  {
    id: 'c1', name: '光影旅人', avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Chinese%20man%20in%20casual%20style%2C%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-1-x9&orientation=squarish',
    text: '用了牛牛影视快两年了，片源更新速度真的没话说。之前找一些冷门老电影特别麻烦，这里基本都有。画质也清晰，投屏到电视上和家人一起看，体验拉满。',
    date: '3 天前', rating: 5,
  },
  {
    id: 'c2', name: '追剧小能手', avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Chinese%20woman%20with%20gentle%20smile%2C%20natural%20lighting%2C%20soft%20background%2C%20professional%20headshot%20style%2C%20friendly%20atmosphere&width=80&height=80&seq=avatar-2-x9&orientation=squarish',
    text: '作为一个每天追剧的人，最大的感受就是方便。手机平板电脑无缝切换，下班路上看一半回家接着看，进度自动同步。APP 的弹幕功能也挺有意思的，边看边聊不孤单。',
    date: '5 天前', rating: 5,
  },
  {
    id: 'c3', name: '电影发烧友', avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20Chinese%20man%20with%20glasses%2C%20intellectual%20look%2C%20soft%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-3-x9&orientation=squarish',
    text: '资源全、更新快、画质好，这三点牛牛影视都做到了。特别喜欢他们的专题策划，经常能发现一些平时没注意到的好片子。唯一希望的是能增加更多 4K 资源。',
    date: '1 周前', rating: 4,
  },
];

export const indexItems = [
  { id: 'i1', title: '动作电影', count: '1,286 部', icon: 'ri-sword-line' },
  { id: 'i2', title: '喜剧电影', count: '952 部', icon: 'ri-emotion-laugh-line' },
  { id: 'i3', title: '爱情电影', count: '1,103 部', icon: 'ri-heart-line' },
  { id: 'i4', title: '科幻电影', count: '768 部', icon: 'ri-rocket-line' },
  { id: 'i5', title: '国产剧集', count: '2,341 部', icon: 'ri-china-railway-line' },
  { id: 'i6', title: '海外剧集', count: '1,897 部', icon: 'ri-global-line' },
  { id: 'i7', title: '热门综艺', count: '1,456 部', icon: 'ri-tv-line' },
  { id: 'i8', title: '动漫番剧', count: '3,210 部', icon: 'ri-ghost-line' },
];

export const rankingItems = [
  { rank: 1, title: '庆余年 第二季', type: '电视剧', heat: '9.8', trend: 'up', desc: '张若昀、李沁主演古装权谋大剧' },
  { rank: 2, title: '死侍与金刚狼', type: '电影', heat: '9.6', trend: 'up', desc: '漫威年度超级英雄动作喜剧' },
  { rank: 3, title: '墨雨云间', type: '电视剧', heat: '9.4', trend: 'up', desc: '吴谨言、王星越古装复仇爽剧' },
  { rank: 4, title: '歌手2025', type: '综艺', heat: '9.3', trend: 'stable', desc: '华语乐坛顶级歌手竞演节目' },
  { rank: 5, title: '你比星光美丽', type: '电视剧', heat: '9.1', trend: 'up', desc: '谭松韵、许凯都市甜宠剧' },
  { rank: 6, title: '鱿鱼游戏 第二季', type: '电视剧', heat: '8.9', trend: 'stable', desc: 'Netflix 全球现象级韩剧续作' },
  { rank: 7, title: '玫瑰的故事', type: '电视剧', heat: '8.7', trend: 'new', desc: '刘亦菲主演都市女性成长剧' },
];

export const contactData = {
  title: '联系牛牛影视',
  subtitle: '资源反馈、合作洽谈、问题建议，我们期待听到你的声音',
  email: 'feedback@niuniuys.com',
  wechat: 'niuniu_movie',
  qq: '800123456',
};